import styled from "styled-components";
import { ISelectProps, ITitleProps } from "./type";

const Select = styled.select<ISelectProps>`
	width: 100%;
	border: 1px solid #d9d9d9;
	color: #2d3436;
	border-radius: 5px;
	opacity: 1;
	outline: none;
	background: #fffff;
	font: normal normal 18px/22px Lato;
	background: url("data:image/svg+xml,<svg height='10px' width='10px' viewBox='0 0 16 16' fill='%23000000' xmlns='http://www.w3.org/2000/svg'><path d='M7.247 11.14 2.451 5.658C1.885 5.013 2.345 4 3.204 4h9.592a1 1 0 0 1 .753 1.659l-4.796 5.48a1 1 0 0 1-1.506 0z'/></svg>")
		no-repeat;
	background-position: calc(100% - 0.75rem) center !important;
	-moz-appearance: none !important;
	-webkit-appearance: none !important;
	appearance: none !important;
	padding-right: 1rem !important;
	&:after {
		padding: 10px;
	}
	padding: 10px 15px 10px 15px;
	font: 14px;
	@media (min-width: 1536px) {
		font: 20px;
		padding: 12px 18px 12px 18px;
	}
	&::placeholder {
		color: #808080;
		opacity: 1;
	}
	&::-ms-expand {
		display: none;
	}
	&:-ms-input-placeholder {
		color: #808080;
	}

	&::-ms-input-placeholder {
		color: #808080;
	}

	&:disabled {
		cursor: not-allowed;
	}
	${(props) =>
		props.height &&
		`
      height: ${props.height}
    `}
	${(props) =>
		props.font &&
		`
      font: ${props.font}
    `}
  ${(props) =>
		props.padding &&
		`
      padding: ${props.padding}
    `}
`;
const Option = styled.option`
	padding: 13px 0px;
	background: #f2f3f7;
	color: #2d3436;
	font: normal normal 14px Lato;
	@media (min-width: 1536px) {
		font: normal normal normal 20px Lato;
	}
`;

const Title = styled.h2<ITitleProps>`
	color: #2d3436;
	font: normal normal bold 18px/22px Lato;
`;

export default {
	Select,
	Title,
	Option,
};
